import { Box, Button, Modal, Typography } from "@mui/material"
import React, { useEffect, useState } from "react"
import { getUserRoles, removeRoleFromUser } from "../../../../../../../api/apiCall";
import { useAuth } from "../../../../../../../auth/auth";
import {Modal as ModalAntd} from 'antd';
import { toast } from "react-toastify";
import AddRole from "../Modal/AddRole";
import { style } from "../../../../style";

const UserRoles = ({userId}: any) => {
    const {state} = useAuth();
    const [roles, setRoles] = useState<any>([]);
    const [open, setOpen] = useState(false);
    const [, setOpenDeleteModal] = useState(false);

    const getAllUserRoles = async () => {
        const response = await getUserRoles(state.user?.token, userId);
        setRoles(response);
    };

    const removeRole = async (roleId: any) => {
        const response: any = await removeRoleFromUser(state.user?.token, roleId, userId);
        if(response.status === 200) {
            toast.error('Role removed successfully!');
            getAllUserRoles()
        } else {
            toast.error('Something went Wrong!')
        }
    }

    useEffect(() => {
        getAllUserRoles();
    }, []);

    return (
        <>
            <Box sx={{maxWidth: 650, margin: "auto", backgroundColor: "#fff", padding: 5}} mt={2}>
                <Box display={"flex"} justifyContent={"space-between"}>
                    <Typography fontWeight={"bold"}>User Roles</Typography>
                    <Button
                        variant="contained"
                        style={{boxShadow: "none"}}
                        onClick={() => setOpen(true)}
                    >
                        Add New Role to User
                    </Button>
                </Box>
                {roles.map((role: any) => (
                    <Box display={"flex"} justifyContent={"space-between"} sx={{padding: 1, mt: 2, borderRadius: 1, border: '1px solid lightgray'}}>
                        <Typography mt={1}>{role.roleName}</Typography>
                        <Button
                            color="error"
                            onClick={() => {
                                setOpenDeleteModal(true);
                                ModalAntd.confirm({
                                    title: `Are you sure you want to delete ${role.roleName} role?`,
                                    onOk: () => removeRole(role.id),
                                    onCancel: () => setOpenDeleteModal(false),
                                    okButtonProps: { danger: true },
                                    okText: 'YES',
                                    cancelText: 'NO',
                                    centered: true
                                });
                            }}
                        >
                            Remove
                        </Button>
                    </Box>
                ))}
            </Box>
            <Modal
                title={`Add New Post`}
                onClose={() => setOpen(false)}
                open={open}
            >
                <Box sx={style}>
                    <AddRole userId={userId} getAllUserRoles={getAllUserRoles} setOpen={setOpen} />
                </Box>
            </Modal>
        </>
    )
}

export default UserRoles;
